import { render } from "./AcceptInvite.vue?vue&type=template&id=988cda9c&scoped=true"
import script from "./AcceptInvite.vue?vue&type=script&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&lang=js"

import "./AcceptInvite.vue?vue&type=style&index=0&id=988cda9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988cda9c"]])

export default __exports__